export default __webpack_public_path__ + "static/media/wealth.38ca4602.png";